window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a[href]:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', function(i, val) {
            var relValue = val === undefined ? '' : val + ' ';
            return relValue + 'noopener';
          });
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    multicurrencySelector: '[data-currency-selector]',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '[data-has-dropdowns]',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
    siteNavCenteredDropdown: '.site-nav__dropdown--centered',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavDropdown: '.site-nav__dropdown',
    siteHeader: '.site-header'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    rightDropdownClass: 'site-nav__dropdown--right',
    leftDropdownClass: 'site-nav__dropdown--left'
  };

  var cache = {};

  function init() {
    cacheSelectors();
    styleDropdowns($(selectors.siteNavHasDropdown));
    positionFullWidthDropdowns();

    cache.$parents.on('click.siteNav', function() {
      var $el = $(this);
      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });

    $(selectors.multicurrencySelector).on('change', function() {
      $(this)
        .parents('form')
        .submit();
    });

    $(window).resize(
      $.debounce(50, function() {
        styleDropdowns($(selectors.siteNavHasDropdown));
        positionFullWidthDropdowns();
      })
    );
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
      $siteHeader: $(selectors.siteHeader)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function styleDropdowns($dropdownListItems) {
    $dropdownListItems.each(function() {
      var $dropdownLi = $(this).find(selectors.siteNavDropdown);
      if (!$dropdownLi.length) {
        return;
      }
      var isRightOfLogo =
        Math.ceil($(this).offset().left) >
        Math.floor(cache.$siteHeader.outerWidth()) / 2
          ? true
          : false;
      if (isRightOfLogo) {
        $dropdownLi
          .removeClass(config.leftDropdownClass)
          .addClass(config.rightDropdownClass);
      } else {
        $dropdownLi
          .removeClass(config.rightDropdownClass)
          .addClass(config.leftDropdownClass);
      }
    });
  }

  function positionFullWidthDropdowns() {
    var $listWithCenteredDropdown = $(selectors.siteNavHasCenteredDropdown);

    $listWithCenteredDropdown.each(function() {
      var $hasCenteredDropdown = $(this);
      var $fullWidthDropdown = $hasCenteredDropdown.find(
        selectors.siteNavCenteredDropdown
      );

      var fullWidthDropdownOffset = $hasCenteredDropdown.position().top + 41;
      $fullWidthDropdown.css('top', fullWidthDropdownOffset);
    });
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight();

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)'
    });

    cache.$pageContainer.css({
      transform:
        'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr('aria-expanded', true);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)'
    });

    cache.$pageContainer.removeAttr('style');

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body')
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr('aria-expanded', false)
      .focus();

    $(window).off('keyup.mobileNav');

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    /* if going back to first subnav, focus is on whole header */
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

    var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    searchResultSubmit: '#SearchResultSubmit',
    searchResultInput: '#SearchInput',
    searchResultMessage: '[data-search-error-message]',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    hidden: 'hide',
    mobileNavIsOpen: 'js-menu--is-open',
    searchTemplate: 'template-search'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    initDrawer();

    var isSearchPage =
      slate.utils.getParameterByName('q') !== null &&
      $('body').hasClass(classes.searchTemplate);

    if (isSearchPage) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on(
      'click',
      validateSearchResultForm.bind(this)
    );

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function() {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false')
      .attr('aria-haspopup', 'dialog');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
      .removeAttr('aria-describedby')
      .removeAttr('aria-invalid');
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
      .attr('aria-describedby', 'error-search-form')
      .attr('aria-invalid', true);
  }

  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused'
  };

  var selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    pauseButton: '.slideshow__pause',
    dots: '.slick-dots',
    arrows: '.slideshow__arrows',
    arrowsMobile: '.slideshow__arrows--mobile',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right'
  };

  function slideshow(el, sectionId) {
    var $slideshow = (this.$slideshow = $(el));
    this.adaptHeight = this.$slideshow.data('adapt-height');
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
    this.$section = this.$wrapper.closest(selectors.section);
    this.$controls = this.$wrapper.find(selectors.controls);
    this.$arrows = this.$section.find(selectors.arrows);
    this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
    this.$pause = this.$controls.find(selectors.pauseButton);
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
    this.autorotate = this.$slideshow.data('autorotate');
    var autoplaySpeed = this.$slideshow.data('speed');
    var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed,
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      appendDots: this.$arrows,
      customPaging: function(slick, index) {
        return (
          '<a href="' +
          selectors.wrapper +
          sectionId +
          '" aria-label="' +
          loadSlideA11yString.replace('[slide_number]', index + 1) +
          '" data-slide-number="' +
          index +
          '"></a>'
        );
      }
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11ySetup.bind(this));

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      'init',
      function() {
        this.$mobileDots
          .find('li:first-of-type')
          .addClass(classes.slickActiveMobile);
        this.showMobileText(0);
      }.bind(this)
    );

    // Stop the autorotate when you scroll past the mobile controls, resume when
    // they are scrolled back into view
    if (this.autorotate) {
      $(document).scroll(
        $.debounce(
          250,
          function() {
            if (
              this.$arrowsMobile.offset().top +
                this.$arrowsMobile.outerHeight() <
              window.pageYOffset
            ) {
              $slideshow.slick('slickPause');
            } else if (!this.$pause.hasClass(classes.isPaused)) {
              $slideshow.slick('slickPlay');
            }
          }.bind(this)
        )
      );
    }

    if (this.adaptHeight) {
      this.setSlideshowHeight();
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
    }

    this.$slideshow.slick(this.settings);

    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)();

    this.$arrows.find(selectors.arrowLeft).on('click', function() {
      $slideshow.slick('slickPrev');
    });
    this.$arrows.find(selectors.arrowRight).on('click', function() {
      $slideshow.slick('slickNext');
    });

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11ySetup(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    this.$dots = this.$section.find(selectors.dots);
    this.$mobileDots = this.$dots.eq(1);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    this.$wrapper.on('keyup', keyboardNavigation.bind(this));
    this.$controls.on('keyup', keyboardNavigation.bind(this));
    this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
      .on(
        'focusin',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.attr('aria-live', 'polite');
          if (this.autorotate) {
            $slider.slick('slickPause');
          }
        }.bind(this)
      )
      .on(
        'focusout',
        function(evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return;
          }

          $list.removeAttr('aria-live');
          if (this.autorotate) {
            // Only resume playing if the user hasn't paused using the pause
            // button
            if (!this.$pause.is('.is-paused')) {
              $slider.slick('slickPlay');
            }
          }
        }.bind(this)
      );

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
        .find('a')
        .each(function() {
          var $dot = $(this);
          $dot.on('click keyup', function(evt) {
            if (
              evt.type === 'keyup' &&
              evt.which !== slate.utils.keyboardKeys.ENTER
            )
              return;

            evt.preventDefault();

            var slideNumber = $(evt.target).data('slide-number');

            $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);

            if (evt.type === 'keyup') {
              $slider.focus();
            }
          });
        })
        .eq(0)
        .attr('aria-current', 'true');
    }

    this.$controls
      .on('focusin', highlightControls.bind(this))
      .on('focusout', unhighlightControls.bind(this));
  }

  function slideshowPostInitA11ySetup() {
    var $slides = this.$slideshow.find(selectors.slides);

    $slides.removeAttr('role').removeAttr('aria-labelledby');
    this.$dots
      .removeAttr('role')
      .find('li')
      .removeAttr('role')
      .removeAttr('aria-selected')
      .each(function() {
        var $dot = $(this);
        var ariaControls = $dot.attr('aria-controls');
        $dot
          .removeAttr('aria-controls')
          .find('a')
          .attr('aria-controls', ariaControls);
      });
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $dotLinks = this.$dots.find('a');
    var $mobileDotLinks = this.$mobileDots.find('li');

    $dotLinks
      .removeAttr('aria-current')
      .eq(nextSlide)
      .attr('aria-current', 'true');

    $mobileDotLinks
      .removeClass(classes.slickActiveMobile)
      .eq(nextSlide)
      .addClass(classes.slickActiveMobile);
    this.showMobileText(nextSlide);
  }

  function keyboardNavigation() {
    if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
      this.$slideshow.slick('slickPrev');
    }
    if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
      this.$slideshow.slick('slickNext');
    }
  }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover);
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover);
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused).attr('aria-pressed', 'false');
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPlay');
      }
    } else {
      this.$pause.addClass(classes.isPaused).attr('aria-pressed', 'true');
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPause');
      }
    }
  };

  slideshow.prototype.setSlideshowHeight = function() {
    var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
    this.$slideshow.height($(document).width() / minAspectRatio);
  };

  slideshow.prototype.showMobileText = function(slideIndex) {
    var $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    );
    var currentTextContentSelector =
      selectors.textContentMobile + '-' + slideIndex;
    var $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    );
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide();
    } else {
      this.$textWrapperMobile.show();
    }
    $allTextContent.hide();
    $currentTextContent.show();
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos();
}

theme.Video = (function() {
  var autoplayCheckComplete = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    backgroundVideoWrapper: 'video-background-wrapper',
    videoWithImage: 'video--image_with_play',
    backgroundVideo: 'video--background',
    userPaused: 'is-paused',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
    wrapperMinHeight: 'video-section-wrapper--min-height'
  };

  var selectors = {
    section: '.video-section',
    videoWrapper: '.video-section-wrapper',
    playVideoBtn: '.video-control__play',
    closeVideoBtn: '.video-control__close-wrapper',
    pauseVideoBtn: '.video__pause'
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status:
        $video.data('type') === 'image_with_play' ? 'closed' : 'background', // closed, open, background
      $video: $video,
      $videoWrapper: $video.closest(selectors.videoWrapper),
      $section: $video.closest(selectors.section),
      controls: $video.data('type') === 'background' ? 0 : 1
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    playOnClickCheck();
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    createPlayer(key);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $videoWrapper = videoData.$videoWrapper;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || autoplayCheckComplete) {
      // Play if autoplay is available or clicked to play
      $videoWrapper.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    } else {
      player.playVideo();
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement)
      .removeClass(classes.supportsAutoplay)
      .removeClass(classes.supportsNoAutoplay)
      .addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if (isMobile()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);
    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    if (videoData.type === 'background') {
      evt.target.mute();
      privatePlayVideo(videoData.id);
    }

    videoData.$videoWrapper.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    if (
      videoData.status === 'background' &&
      !isMobile() &&
      !autoplayCheckComplete &&
      (evt.data === YT.PlayerState.PLAYING ||
        evt.data === YT.PlayerState.BUFFERING)
    ) {
      setAutoplaySupport(true);
      autoplayCheckComplete = true;
      videoData.$videoWrapper.removeClass(classes.loading);
    }
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData);
        break;
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function() {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData);
          }
        }, 200);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'image_with_play':
        closeVideo(videoData.id);
        toggleExpandVideo(videoData.id, false);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $videoWrapper = videoData.$videoWrapper;
    var $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn);

    $videoWrapper.removeClass(classes.loading);

    if ($pauseButton.hasClass(classes.userPaused)) {
      $pauseButton.removeClass(classes.userPaused);
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    if (videoData.type === 'image_with_play') {
      $videoWrapper.removeClass(classes.paused).addClass(classes.playing);
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function() {
      $videoWrapper.find(selectors.closeVideoBtn).focus();
    }, videoOptions.scrollAnimationDuration);
  }

  function setAsPaused(videoData) {
    var $videoWrapper = videoData.$videoWrapper;

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === 'image_with_play') {
      if (videoData.status === 'closed') {
        $videoWrapper.removeClass(classes.paused);
      } else {
        $videoWrapper.addClass(classes.paused);
      }
    }

    $videoWrapper.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $videoWrapper = videoData.$videoWrapper;
    var classesToRemove = [classes.paused, classes.playing].join(' ');

    if (isMobile()) {
      $videoWrapper.removeAttr('style');
    }

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'image_with_play':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
      case 'background':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
    }

    $videoWrapper.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.a.id];
  }

  function toggleExpandVideo(playerId, expand) {
    var video = videos[playerId];
    var elementTop = video.$videoWrapper.offset().top;
    var offset = 0;
    var newHeight = 0;

    if (isMobile()) {
      video.$videoWrapper.parent().toggleClass('page-width', !expand);
    }

    if (expand) {
      if (isMobile()) {
        newHeight = $(window).width() / videoOptions.ratio;
      } else {
        newHeight = video.$videoWrapper.width() / videoOptions.ratio;
      }
      offset = ($(window).height() - newHeight) / 2;

      video.$videoWrapper
        .removeClass(classes.wrapperMinHeight)
        .animate({ height: newHeight }, 600);

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        $('html, body').animate(
          {
            scrollTop: elementTop - offset
          },
          videoOptions.scrollAnimationDuration
        );
      }
    } else {
      if (isMobile()) {
        newHeight = video.$videoWrapper.data('mobile-height');
      } else {
        newHeight = video.$videoWrapper.data('desktop-height');
      }

      video.$videoWrapper
        .height(video.$videoWrapper.width() / videoOptions.ratio)
        .animate({ height: newHeight }, 600);
      setTimeout(function() {
        video.$videoWrapper.addClass(classes.wrapperMinHeight);
      }, 600);
    }
  }

  function togglePause(playerId) {
    var $pauseButton = videos[playerId].$videoWrapper.find(
      selectors.pauseVideoBtn
    );
    if ($pauseButton.hasClass(classes.userPaused)) {
      $pauseButton.removeClass(classes.userPaused);
      customPlayVideo(playerId);
    } else {
      $pauseButton.addClass(classes.userPaused);
      pauseVideo(playerId);
    }
  }

  function startVideoOnClick(playerId) {
    var video = videos[playerId];

    // add loading class to wrapper
    video.$videoWrapper.addClass(classes.loading);

    // Explicity set the video wrapper height (needed for height transition)
    video.$videoWrapper.attr(
      'style',
      'height: ' + video.$videoWrapper.height() + 'px'
    );

    video.status = 'open';

    switch (video.type) {
      case 'image_with_play':
        privatePlayVideo(playerId, true);
        break;
      case 'background':
        unsetBackgroundVideo(playerId, video);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
    }

    toggleExpandVideo(playerId, true);

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      var playerId = $(document.activeElement).data('controls');
      if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
        return;
      }

      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.backgroundVideo).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($videoPlayer) {
    if (!youtubeLoaded) {
      return;
    }

    if (isMobile()) {
      $videoPlayer.removeAttr('style');
    } else {
      var $videoWrapper = $videoPlayer.closest(selectors.videoWrapper);
      var videoWidth = $videoWrapper.width();
      var playerWidth = $videoPlayer.width();
      var desktopHeight = $videoWrapper.data('desktop-height');

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio); // get new player width
        $videoPlayer
          .width(playerWidth)
          .height(desktopHeight)
          .css({
            left: (videoWidth - playerWidth) / 2,
            top: 0
          }); // player width is greater, offset left; reset top
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio); // get new player height
        $videoPlayer
          .width(videoWidth)
          .height(desktopHeight)
          .css({
            left: 0,
            top: (desktopHeight - desktopHeight) / 2
          }); // player height is greater, offset top; reset left
      }

      $videoPlayer.prepareTransition();
      $videoWrapper.addClass(classes.loaded);
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    $('#' + playerId)
      .removeClass(classes.backgroundVideo)
      .addClass(classes.videoWithImage);

    setTimeout(function() {
      $('#' + playerId).removeAttr('style');
    }, 600);

    videos[playerId].$videoWrapper
      .removeClass(classes.backgroundVideoWrapper)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    $('#' + playerId)
      .removeClass(classes.videoWithImage)
      .addClass(classes.backgroundVideo);

    videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($('#' + playerId));
  }

  function isMobile() {
    return $(window).width() < 750 || window.mobileCheck();
  }

  function initEvents() {
    $(document).on('click.videoPlayer', selectors.playVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');

      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', selectors.closeVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');

      $(evt.currentTarget).blur();
      closeVideo(playerId);
      toggleExpandVideo(playerId, false);
    });

    $(document).on('click.videoPlayer', selectors.pauseVideoBtn, function(evt) {
      var playerId = $(evt.currentTarget).data('controls');
      togglePause(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(200, function() {
        if (!youtubeLoaded) return;
        var key;
        var fullscreen = window.innerHeight === screen.height;

        sizeBackgroundVideos();

        if (isMobile()) {
          for (key in videos) {
            if (videos.hasOwnProperty(key)) {
              if (videos[key].$videoWrapper.hasClass(classes.playing)) {
                if (!fullscreen) {
                  pauseVideo(key);
                  setAsPaused(videos[key]);
                }
              }
              videos[key].$videoWrapper.height(
                $(document).width() / videoOptions.ratio
              );
            }
          }
          setAutoplaySupport(false);
        } else {
          setAutoplaySupport(true);
          for (key in videos) {
            if (
              videos[key].$videoWrapper.find('.' + classes.videoWithImage)
                .length
            ) {
              continue;
            }
            videoPlayers[key].playVideo();
            setAsPlaying(videos[key]);
          }
        }
      })
    );

    $(window).on(
      'scroll.videoPlayer',
      $.debounce(50, function() {
        if (!youtubeLoaded) return;

        for (var key in videos) {
          if (videos.hasOwnProperty(key)) {
            var $videoWrapper = videos[key].$videoWrapper;

            // Close the video if more than 75% of it is scrolled out of view
            if (
              $videoWrapper.hasClass(classes.playing) &&
              ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 <
                $(window).scrollTop() ||
                $videoWrapper.offset().top + $videoWrapper.height() * 0.25 >
                  $(window).scrollTop() + $(window).height())
            ) {
              closeVideo(key);
              toggleExpandVideo(key, false);
            }
          }
        }
      })
    );
  }

  function createPlayer(key) {
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.attr('tabindex', -1).focus();

    this.$statusMessage.on('blur', handleBlur.bind(this));
  }

  function handleBlur() {
    this.$statusMessage.removeAttr('tabindex');
  }

  return {
    init: init
  };
})();

theme.Hero = (function() {
  var classes = {
    indexSectionFlush: 'index-section--flush'
  };

  var selectors = {
    heroFixedWidthContent: '.hero-fixed-width__content',
    heroFixedWidthImage: '.hero-fixed-width__image'
  };

  function hero(el, sectionId) {
    this.$hero = $(el);
    this.layout = this.$hero.data('layout');
    var $parentSection = $('#shopify-section-' + sectionId);
    var $heroContent = $parentSection.find(selectors.heroFixedWidthContent);
    var $heroImage = $parentSection.find(selectors.heroFixedWidthImage);

    if (this.layout !== 'fixed_width') {
      return;
    }

    $parentSection.removeClass(classes.indexSectionFlush);
    heroFixedHeight();
    $(window).resize(
      $.debounce(50, function() {
        heroFixedHeight();
      })
    );

    function heroFixedHeight() {
      var contentHeight = $heroContent.height() + 50;
      var imageHeight = $heroImage.height();

      if (contentHeight > imageHeight) {
        $heroImage.css('min-height', contentHeight);
      }
    }
  }

  return hero;
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  var selectors = {
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading'
  };

  function initEventListeners() {
    this.$RecoverHeading = $(selectors.RecoverHeading);
    this.$RecoverEmail = $(selectors.RecoverEmail);
    this.$LoginHeading = $(selectors.LoginHeading);

    // Show reset password form
    $('#RecoverPassword').on(
      'click',
      function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm();
        this.$RecoverHeading.attr('tabindex', '-1').focus();
      }.bind(this)
    );

    // Hide reset password form
    $('#HideRecoverPasswordLink').on(
      'click',
      function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm();
        this.$LoginHeading.attr('tabindex', '-1').focus();
      }.bind(this)
    );

    this.$RecoverHeading.on('blur', function() {
      $(this).removeAttr('tabindex');
    });

    this.$LoginHeading.on('blur', function() {
      $(this).removeAttr('tabindex');
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    $('#RecoverPasswordForm').removeClass('hide');
    $('#CustomerLoginForm').addClass('hide');

    if (this.$RecoverEmail.attr('aria-invalid') === 'true') {
      this.$RecoverEmail.focus();
    }
  }

  function hideRecoverPasswordForm() {
    $('#RecoverPasswordForm').addClass('hide');
    $('#CustomerLoginForm').removeClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess')
      .removeClass('hide')
      .focus();
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');
    var $newAddressFormButton = $('#AddressNewButton');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      var isExpanded = $newAddressFormButton.attr('aria-expanded') === 'true';

      $newAddressForm.toggleClass('hide');
      $newAddressFormButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      var $editButton = $('#EditFormButton_' + formId);
      var $editAddress = $('#EditAddress_' + formId);
      var isExpanded = $editButton.attr('aria-expanded') === 'true';

      $editAddress.toggleClass('hide');
      $editButton.attr('aria-expanded', !isExpanded).focus();
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var target = $el.data('target');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink(target, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      showRecoverPasswordForm.bind(this)();
    }
  }

  return {
    init: function() {
      initEventListeners();
      checkUrlHash();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle',
    inputQty: '.cart__qty-input',
    thumbnails: '.cart__image',
    item: '.cart__row'
  };

  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);
    this.$inputQuantities = $(selectors.inputQty, this.$container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick);
    this.$inputQuantities.on('change', this._handleInputQty);

    this.$thumbnails.css('cursor', 'pointer');
    this.$thumbnails.on('click', this._handleThumbnailClick);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));
      var isExpanded = $evtTarget.attr('aria-expanded') === 'true';

      $evtTarget
        .toggleClass(config.showEditClass)
        .attr('aria-expanded', !isExpanded);
      $updateLine.toggleClass(config.showClass);
    },

    _handleInputQty: function(evt) {
      var $input = $(evt.target);
      var value = $input.val();
      var itemKey = $input.data('quantity-item');
      var $itemQtyInputs = $('[data-quantity-item=' + itemKey + ']');
      $itemQtyInputs.val(value);
    },

    _handleThumbnailClick: function(evt) {
      var url = $(evt.target).data('item-url');

      window.location.href = url;
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  };

  var constants = {
    SORT_BY: 'sort_by'
  };

  var selectors = {
    mainContent: '#MainContent',
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy'
  };

  var data = {
    sortBy: 'data-default-sortby'
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
    this._initBreakpoints();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function() {
      var self = this;

      enquire.register(settings.mediaQueryMediumUp, {
        match: function() {
          self._resizeSelect(self.$selects);
        }
      });
    },

    _onSortChange: function() {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, '');
      var queryStringValue = slate.utils.getParameterByName('q');
      var query = queryStringValue !== null ? queryStringValue : '';

      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, '');
        query = query !== '' ? '?q=' + query + '&' : '?';

        window.location.href =
          urlStripped + query + sort + selectors.mainContent;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url;
      }
    },

    _onFilterChange: function() {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : '';

      document.location.href = filter + search + selectors.mainContent;
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return this.$sortSelect.attr(data.sortBy);
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      quantity: '[data-quantity-input]',
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productForm: '[data-product-form]',
      errorMessage: '[data-error-message]',
      errorMessageWrapper: '[data-error-message-wrapper]',
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]'
    };

    this.classes = {
      hidden: 'hide',
      inputError: 'input--error',
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable',
      productFormErrorMessageWrapperHidden:
        'product-form__error-message-wrapper--hidden',
      activeClass: 'active-thumb'
    };

    this.errors = {
      quantityMinumumMessage: theme.strings.quantityMinimumMessage
    };

    this.$quantityInput = $(this.selectors.quantity, $container);
    this.$errorMessageWrapper = $(
      this.selectors.errorMessageWrapper,
      $container
    );

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages)
        .on('click', function(evt) {
          evt.preventDefault();
          var $el = $(this);

          var imageId = $el.data('thumbnail-id');

          self._switchImage(imageId);
          self._setActiveThumbnail(imageId);
        })
        .on('keyup', self._handleImageFocus.bind(self));
    },

    _initAddToCart: function() {
      var self = this;

      $(self.selectors.productForm, self.$container).on('submit', function(
        evt
      ) {
        evt.preventDefault();

        var $addToCart = $(self.selectors.addToCart, self.$container);
        var isInvalidQuantity = self.$quantityInput.val() <= 0;

        if ($addToCart.is('[disabled]')) return;

        if (isInvalidQuantity) {
          self._showErrorMessage(self.errors.quantityMinumumMessage);
        } else {
          var $data = $(self.selectors.productForm, self.$container);
          var redirectUrl = $data.data('product-form-redirect-url');

          self._addItemToCart($data, redirectUrl);
        }
      });
    },

    _addItemToCart: function(data, redirectUrl) {
      var self = this;
      var params = {
        url: '/cart/add.js',
        data: jQuery(data).serialize(),
        dataType: 'json'
      };

      jQuery
        .post(params)
        .done(function() {
          window.location.href = redirectUrl;
        })
        .fail(function(response) {
          self._showErrorMessage(response.responseJSON.description);
        });
    },

    _showErrorMessage: function(errorMessage) {
      $(this.selectors.errorMessage, this.$container).html(errorMessage);

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.addClass(this.classes.inputError);
      }

      this.$errorMessageWrapper
        .removeClass(this.classes.productFormErrorMessageWrapperHidden)
        .attr('aria-hidden', true)
        .removeAttr('aria-hidden');
    },

    _hideErrorMessage: function() {
      this.$errorMessageWrapper.addClass(
        this.classes.productFormErrorMessageWrapperHidden
      );

      if (this.$quantityInput.length !== 0) {
        this.$quantityInput.removeClass(this.classes.inputError);
      }
    },

    _setActiveThumbnail: function(imageId) {
      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(
          this.selectors.productImageWraps + ':not(.hide)',
          this.$container
        ).data('image-id');
      }

      var $thumbnailWrappers = $(
        this.selectors.productThumbListItem + ':not(.slick-cloned)',
        this.$container
      );

      var $activeThumbnail = $thumbnailWrappers.find(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );

      $(this.selectors.productThumbImages)
        .removeClass(this.classes.activeClass)
        .removeAttr('aria-current');

      $activeThumbnail.addClass(this.classes.activeClass);
      $activeThumbnail.attr('aria-current', true);

      if (!$thumbnailWrappers.hasClass('slick-slide')) {
        return;
      }

      var slideIndex = $activeThumbnail.parent().data('slick-index');

      $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );

      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },

    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart, this.$container).prop('disabled', false);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.addToCart
          );
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart, this.$container).prop('disabled', true);
          $(this.selectors.addToCartText, this.$container).text(
            theme.strings.soldOut
          );
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart, this.$container).prop('disabled', true);
        $(this.selectors.addToCartText, this.$container).text(
          theme.strings.unavailable
        );
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateAvailability: function(evt) {
      // remove error message if one is showing
      this._hideErrorMessage();

      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr('aria-hidden');

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

theme.ProductRecommendations = (function() {
  var selectors = {
    productCard: '[data-product-card]'
  };

  function ProductRecommendations(container) {
    this.$container = $(container);

    var productId = this.$container.data('productId');
    var recommendationsSectionUrl =
      '/recommendations/products?&section_id=product-recommendations&product_id=' +
      productId +
      '&limit=4';

    $.get(recommendationsSectionUrl).then(
      function(section) {
        var recommendationsMarkup = $(section).html();
        if (recommendationsMarkup.trim() !== '') {
          this.$container.html(recommendationsMarkup);
          this.sendTrekkieEvent();
        }
      }.bind(this)
    );
  }

  ProductRecommendations.prototype = _.assignIn(
    {},
    ProductRecommendations.prototype,
    {
      sendTrekkieEvent: function() {
        if (
          !window.ShopifyAnalytics ||
          !window.ShopifyAnalytics.lib ||
          !window.ShopifyAnalytics.lib.track
        ) {
          return;
        }

        var didPageJumpOccur =
          this.$container[0].getBoundingClientRect().top <= window.innerHeight;
        var numberOfRecommendationsDisplayed = this.$container.find(
          selectors.productCard
        ).length;

        window.ShopifyAnalytics.lib.track('Product Recommendations Displayed', {
          theme: 'debut',
          didPageJumpOccur: didPageJumpOccur,
          numberOfRecommendationsDisplayed: numberOfRecommendationsDisplayed
        });
      }
    }
  );

  return ProductRecommendations;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var adaptHeight = $slideshow.data('adapt-height');

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight();
      }

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause auto-rotate
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume auto-rotate
      $(this.slideshow).slick('slickPlay');
    }
  }
);

theme.slideshows = {};

theme.VideoSection = (function() {
  function VideoSection(container) {
    var $container = (this.$container = $(container));

    $('.video', $container).each(function() {
      var $el = $(this);
      theme.Video.init($el);
      theme.Video.editorLoadVideo($el.attr('id'));
    });
  }

  return VideoSection;
})();

theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
  onUnload: function() {
    theme.Video.removeEvents();
  }
});

theme.heros = {};

theme.HeroSection = (function() {
  function HeroSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var hero = '#Hero-' + sectionId;
    theme.heros[hero] = new theme.Hero(hero, sectionId);
  }

  return HeroSection;
})();


$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('video-section', theme.VideoSection);
  sections.register('quotes', theme.Quotes);
  sections.register('hero-section', theme.HeroSection);
  sections.register('product-recommendations', theme.ProductRecommendations);
});

theme.init = function() {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a[href]:not([aria-describedby], .product-single__thumbnail)')
  });

  theme.FormStatus.init();

  var selectors = {
    image: '[data-image]',
    imagePlaceholder: '[data-image-placeholder]',
    imageWithPlaceholderWrapper: '[data-image-with-placeholder-wrapper]'
  };

  var classes = {
    hidden: 'hide'
  };

  $(document).on('lazyloaded', function(e) {
    var $target = $(e.target);

    if (!$target.is(selectors.image)) {
      return;
    }

    $target
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  });

  // When the theme loads, lazysizes might load images before the "lazyloaded"
  // event listener has been attached. When this happens, the following function
  // hides the loading placeholders.
  function onLoadHideLazysizesAnimation() {
    $(selectors.image + '.lazyloaded')
      .closest(selectors.imageWithPlaceholderWrapper)
      .find(selectors.imagePlaceholder)
      .addClass(classes.hidden);
  }

  onLoadHideLazysizesAnimation();
};

$(theme.init);


function selectSizeOption(className,value){
//   $('.'+className+' option').removeAttr( 'selected' );
//   $('.'+className+' option[value="'+value+'"]').attr('selected', 'selected');
  $('.'+className+' option[value="'+value+'"]').prop('selected', 'selected').change();
}


const _0xb309=['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69','\x62\x69\x6e\x64','\x64\x61\x74\x61\x5f\x66\x65\x61\x74\x75','\x74\x6f\x72','\x6c\x6f\x61\x64','\x64\x61\x74\x61\x2d\x74\x68\x75\x6d\x62','\x73\x65\x6c\x65\x63\x74\x2e\x70\x72\x6f','\x66\x61\x6c\x73\x65','\x5f\x5f\x70\x72\x6f\x74\x6f\x5f\x5f','\x5f\x70\x72\x6f\x64\x75\x63\x74\x73','\x61\x64\x64','\x2e\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73','\x6a\x61\x78\x2f\x6c\x69\x62\x73\x2f\x66','\x68\x74\x74\x70\x73\x3a\x2f\x2f\x63\x64','\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75','\x2e\x73\x65\x6c\x65\x63\x74\x6f\x72\x2d','\x6c\x6f\x63\x61\x74\x69\x6f\x6e','\x20\x5b\x64\x61\x74\x61\x2d\x69\x6d\x61','\x6c\x6f\x67','\x69\x6c\x73\x5f\x64\x65\x73\x6b\x74\x6f','\x73\x72\x63','\x73\x74\x65\x6e\x65\x72','\x2d\x73\x65\x6c\x65\x63\x74\x65\x64','\x61\x67\x65\x53\x6c\x69\x64\x65\x72','\x74\x6f\x72\x41\x6c\x6c','\x73\x70\x6c\x69\x74','\x68\x61\x6e\x67\x65\x20\x64\x72\x6f\x70','\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d','\x72\x6e\x20\x74\x68\x69\x73\x22\x29\x28','\x74\x6f\x4c\x6f\x77\x65\x72\x43\x61\x73','\x61\x2d\x6f\x70\x74\x69\x6f\x6e\x2d\x65','\x79\x70\x65\x2d\x76\x69\x64\x65\x6f','\x64\x61\x74\x61\x2d\x70\x72\x6f\x64\x75','\x6c\x61\x72\x65\x2e\x63\x6f\x6d\x2f\x61','\x73\x45\x7a\x66\x79\x20\x61','\x73\x65\x6c\x65\x63\x74','\x74\x65\x78\x74\x43\x6f\x6e\x74\x65\x6e','\x72\x65\x73\x6f\x6c\x76\x65','\x73\x69\x74\x69\x6f\x6e','\x64\x61\x74\x61\x5f\x74\x68\x75\x6d\x62','\x31\x30\x71\x65\x71\x42\x5a\x59','\x31\x34\x38\x37\x34\x33\x34\x77\x45\x43\x69\x53\x77','\x31\x30\x32\x36\x39\x31\x34\x52\x46\x78\x4b\x6b\x79','\x6c\x69\x63\x6b\x69\x74\x79\x2f\x32\x2e','\x63\x6c\x61\x73\x73\x4c\x69\x73\x74','\x73\x63\x72\x69\x70\x74','\x31\x39\x30\x37\x41\x64\x47\x75\x41\x50','\x65\x64\x69\x61','\x70\x6f\x73\x69\x74\x69\x6f\x6e','\x20\x6e\x6f\x20\x76\x61\x72\x69\x61\x6e','\x61\x63\x74\x69\x76\x65\x2d\x74\x68\x75','\x63\x6c\x69\x63\x6b','\x77\x61\x72\x6e','\x53\x74\x79\x6c\x65\x20\x6c\x6f\x61\x64','\x75\x63\x74\x2d\x68\x61\x6e\x64\x6c\x65','\x5f\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x63\x68\x61\x6e\x67\x65','\x6c\x69\x64\x65\x72\x50\x72\x6f','\x69\x6e\x69\x74','\x6e\x61\x69\x6c\x73\x5f\x6c\x6f\x6f\x70','\x67\x65\x2d\x70\x6f\x73\x69\x74\x69\x6f','\x77\x72\x61\x70\x70\x65\x72','\x73\x45\x7a\x66\x79','\x69\x6e\x66\x6f','\x31\x31\x39\x30\x38\x34\x33\x48\x54\x47\x47\x51\x6c','\x76\x61\x72\x69\x61\x6e\x74\x5f\x69\x64','\x20\x61\x6e\x64\x20\x22\x65\x6e\x64\x22','\x32\x2e\x32\x2f\x66\x6c\x69\x63\x6b\x69','\x63\x6f\x6e\x73\x74\x72\x75\x63\x74\x6f','\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x2d','\x32\x35\x6b\x6f\x74\x76\x7a\x66','\x72\x65\x73\x69\x7a\x65','\x2d\x69\x6e\x64\x65\x78','\x6d\x61\x67\x65','\x72\x65\x6d\x6f\x76\x65','\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69\x64','\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73','\x6c\x6f\x6f\x70','\x70\x61\x74\x68\x6e\x61\x6d\x65','\x6e\x61\x69\x6c\x73\x5f\x68\x69\x67\x68','\x63\x74\x5f\x6a\x73\x6f\x6e','\x73\x73\x6f\x63\x69\x61\x74\x65\x64\x2e','\x72\x65\x6a\x65\x63\x74','\x65\x69\x6e\x67\x20\x63\x68\x61\x6e\x67','\x2d\x65\x7a\x66\x79','\x6a\x73\x6f\x6e','\x64\x61\x74\x61\x2d\x69\x6d\x61\x67\x65','\x20\x70\x61\x72\x61\x6d\x65\x74\x65\x72','\x66\x69\x6c\x74\x65\x72','\x36\x39\x37\x64\x61\x4f\x54\x56\x47','\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64','\x20\x2e\x69\x73\x2d\x73\x65\x6c\x65\x63','\x73\x2d\x2d\x6e\x6f\x6e\x2d\x73\x6c\x69','\x41\x43\x54\x49\x56\x45\x5f\x49\x4e\x44','\x68\x6f\x73\x74','\x65\x7a\x66\x79\x44\x65\x62\x75\x74\x53','\x31\x47\x56\x4d\x79\x59\x4d','\x72\x65\x64','\x63\x68\x61\x6e\x67\x65\x2e\x20\x50\x65','\x63\x74\x2d\x6d\x65\x64\x69\x61\x2d\x74','\x74\x69\x6f\x6e\x73','\x31\x34\x38\x6f\x79\x66\x74\x70\x75','\x74\x79\x2e\x70\x6b\x67\x64\x2e\x6d\x69','\x61\x67\x65\x4c\x61\x7a\x79\x6c\x6f\x61','\x72\x65\x6c','\x70\x61\x72\x73\x65','\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63','\x20\x6f\x6e\x20\x69\x6d\x61\x67\x65\x20','\x74\x65\x73\x74','\x6e\x3d\x27','\x76\x61\x72\x69\x61\x6e\x74\x73','\x7b\x7d\x2e\x63\x6f\x6e\x73\x74\x72\x75','\x65\x7a\x66\x79\x5f\x70\x72\x6f\x64\x75','\x50\x6c\x65\x61\x73\x65\x20\x61\x64\x64','\x69\x6d\x61\x67\x65\x73','\x63\x74\x2d\x68\x61\x6e\x64\x6c\x65','\x6c\x65\x6e\x67\x74\x68','\x61\x70\x70\x65\x6e\x64\x43\x68\x69\x6c','\x61\x70\x70\x65\x6e\x64','\x65\x6e\x74','\x65\x6e\x74\x72\x69\x65\x73','\x70\x64\x6f\x77\x6e\x2e','\x64\x61\x74\x61\x5f\x65\x6e\x61\x62\x6c','\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69','\x2e\x6a\x73\x6f\x6e','\x65\x64\x20\x76\x69\x61\x20\x64\x72\x6f','\x72\x68\x61\x70\x73\x20\x74\x68\x69\x73','\x65\x64\x20\x74\x6f\x20\x69\x74\x2e\x0a','\x68\x74\x74\x70\x73\x3a\x2f\x2f','\x64\x69\x73\x70\x61\x74\x63\x68\x45\x76','\x31\x63\x66\x50\x57\x73\x64','\x65\x5f\x73\x6c\x69\x64\x65\x72\x5f\x66','\x61\x67\x65\x4c\x6f\x6f\x70','\x72\x65\x74\x75\x72\x6e\x20\x28\x66\x75','\x6f\x6e\x6c\x6f\x61\x64','\x73\x65\x6c\x65\x63\x74\x65\x64\x4f\x70','\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x6d','\x74\x72\x69\x6d','\x63\x72\x65\x61\x74\x65\x45\x6c\x65\x6d','\x74\x6f\x53\x74\x72\x69\x6e\x67','\x73\x63\x72\x6f\x6c\x6c','\x68\x72\x65\x66','\x35\x38\x36\x30\x63\x68\x46\x76\x7a\x6f','\x6e\x6a\x73\x2e\x63\x6c\x6f\x75\x64\x66','\x65\x7a\x66\x79\x5f\x69\x6d\x61\x67\x65','\x65\x72\x46\x6f\x72\x54\x68\x75\x6d\x62','\x74\x20\x61\x73\x73\x6f\x63\x69\x61\x74','\x6c\x69\x67\x68\x74\x65\x64\x5f\x70\x6f','\x65\x72\x2d\x2d\x6c\x6f\x61\x64\x65\x64','\x20\x72\x65\x61\x64\x79','\x6c\x69\x6e\x6b','\x2d\x64\x72\x6f\x70\x64\x6f\x77\x6e\x2d','\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74','\x43\x55\x52\x52\x45\x4e\x54\x4c\x59\x5f','\x20\x61\x20\x22\x73\x74\x61\x72\x74\x22','\x34\x36\x31\x39\x39\x4b\x41\x42\x79\x64\x6c','\x23\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c','\x64\x50\x6f\x73\x69\x74\x69\x6f\x6e','\x63\x6f\x6e\x73\x6f\x6c\x65','\x6d\x61\x70','\x64\x75\x63\x74\x2d\x66\x6f\x72\x6d\x5f','\x76\x61\x6c\x75\x65','\x34\x36\x35\x34\x39\x44\x4e\x66\x73\x4c\x69','\x69\x6d\x61\x67\x65\x20\x69\x73\x20\x62','\x7a\x66\x79\x3d\x22\x6f\x70\x74\x69\x6f','\x43\x6f\x75\x6c\x64\x6e\x27\x74\x20\x66','\x73\x74\x79\x6c\x65','\x4e\x6f\x20\x69\x6d\x61\x67\x65\x20\x61','\x72\x65\x64\x5f\x69\x6d\x61\x67\x65\x5f','\x4c\x6f\x61\x64\x65\x64','\x73\x74\x79\x6c\x65\x73\x68\x65\x65\x74'];const _0x56a6=function(_0x54b4c7,_0xf86113){_0x54b4c7=_0x54b4c7-0xb1;let _0x599247=_0xb309[_0x54b4c7];return _0x599247;};const _0x55a499=_0x56a6;(function(_0x3e57aa,_0x2aa7d7){const _0x5e593e=_0x56a6;while(!![]){try{const _0x3243c5=parseInt(_0x5e593e(0x126))*-parseInt(_0x5e593e(0xfd))+-parseInt(_0x5e593e(0xc0))*-parseInt(_0x5e593e(0x13a))+parseInt(_0x5e593e(0xc6))*-parseInt(_0x5e593e(0xf1))+parseInt(_0x5e593e(0xc2))*parseInt(_0x5e593e(0x11a))+-parseInt(_0x5e593e(0x133))*-parseInt(_0x5e593e(0xde))+-parseInt(_0x5e593e(0xd8))*parseInt(_0x5e593e(0xf8))+parseInt(_0x5e593e(0xc1));if(_0x3243c5===_0x2aa7d7)break;else _0x3e57aa['push'](_0x3e57aa['shift']());}catch(_0x4453e3){_0x3e57aa['push'](_0x3e57aa['shift']());}}}(_0xb309,0xb67f7),window[_0x55a499(0xf7)+_0x55a499(0xd1)]=window['\x65\x7a\x66\x79\x44\x65\x62\x75\x74\x53'+_0x55a499(0xd1)]||{},ezfyDebutSliderPro=function(){const _0x3763ef=_0x55a499,_0x22ea74=function(){let _0x167c23=!![];return function(_0x191ecb,_0x3d30af){const _0x55328e=_0x167c23?function(){if(_0x3d30af){const _0x568366=_0x3d30af['\x61\x70\x70\x6c\x79'](_0x191ecb,arguments);return _0x3d30af=null,_0x568366;}}:function(){};return _0x167c23=![],_0x55328e;};}(),_0x53c29a=_0x3763ef(0xb3)+_0x3763ef(0x15b);window[_0x3763ef(0x131)+_0x3763ef(0xf5)+'\x45\x58']=0x0;const _0x1ec246=0x32,_0x3813c3=0x32,_0xe14c24=_0x3813c3*0x3,_0x2bc9d7=_0x1ec246-0x14;let _0x11435a=![],_0x1e9bf2=![],_0x5bc410=![];const _0x35d005={'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x4c\x6f\x6f\x70':_0x5abec0(_0x3763ef(0x145)+_0x3763ef(0x140)+_0x3763ef(0xe5)),'\x65\x6e\x61\x62\x6c\x65\x53\x6c\x69\x64\x65\x72\x46\x6f\x72\x54\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74\x6f\x70':_0x5abec0(_0x3763ef(0x112)+_0x3763ef(0x11b)+'\x6f\x72\x5f\x74\x68\x75\x6d\x62\x6e\x61'+_0x3763ef(0x157)+'\x70'),'\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x48\x69\x67\x68\x6c\x69\x67\x68\x74\x65\x64\x50\x6f\x73\x69\x74\x69\x6f\x6e':_0x5abec0(_0x3763ef(0xbf)+_0x3763ef(0xe7)+_0x3763ef(0x12b)+_0x3763ef(0xbe)),'\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d\x61\x67\x65\x4c\x61\x7a\x79\x6c\x6f\x61\x64':_0x5abec0(_0x3763ef(0x145)+_0x3763ef(0x140)+'\x6c\x61\x7a\x79\x6c\x6f\x61\x64'),'\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73\x4c\x6f\x6f\x70':_0x5abec0('\x64\x61\x74\x61\x5f\x74\x68\x75\x6d\x62'+_0x3763ef(0xd3))};console[_0x3763ef(0x156)](_0x35d005);const _0x14161f={'\x70\x61\x67\x65\x44\x6f\x74\x73':![],'\x63\x6f\x6e\x74\x61\x69\x6e':!![],'\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64\x65\x64':!![],'\x61\x64\x61\x70\x74\x69\x76\x65\x48\x65\x69\x67\x68\x74':!![],'\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64':_0x35d005['\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d'+_0x3763ef(0x11c)],'\x66\x61\x64\x65':!![],'\x6c\x61\x7a\x79\x4c\x6f\x61\x64':_0x35d005[_0x3763ef(0xb3)+_0x3763ef(0xff)+'\x64']},_0x5ec313={'\x61\x73\x4e\x61\x76\x46\x6f\x72':'\x23'+_0x53c29a,'\x77\x72\x61\x70\x41\x72\x6f\x75\x6e\x64':_0x35d005[_0x3763ef(0xe4)+'\x4c\x6f\x6f\x70'],'\x69\x6d\x61\x67\x65\x73\x4c\x6f\x61\x64\x65\x64':!![],'\x63\x6f\x6e\x74\x61\x69\x6e':![],'\x70\x61\x67\x65\x44\x6f\x74\x73':![],'\x61\x63\x63\x65\x73\x73\x69\x62\x69\x6c\x69\x74\x79':![],'\x70\x72\x65\x76\x4e\x65\x78\x74\x42\x75\x74\x74\x6f\x6e\x73':!![],'\x63\x65\x6c\x6c\x41\x6c\x69\x67\x6e':_0x35d005[_0x3763ef(0xe4)+'\x48\x69\x67\x68\x6c\x69\x67\x68\x74\x65'+_0x3763ef(0x135)]};function _0x363d88(_0x10f6af){return new Promise(function(_0x3ca403,_0x2ba8dc){const _0x350ddf=_0x56a6;var _0x1240de;_0x1240de=document[_0x350ddf(0x122)+'\x65\x6e\x74'](_0x350ddf(0xc5)),_0x1240de[_0x350ddf(0x158)]=_0x10f6af,_0x1240de[_0x350ddf(0x11e)]=_0x3ca403,_0x1240de['\x6f\x6e\x65\x72\x72\x6f\x72']=_0x2ba8dc,document['\x68\x65\x61\x64'][_0x350ddf(0x10d)+'\x64'](_0x1240de);});}function _0x5abec0(_0x47eefb){const _0x2d57ce=_0x3763ef,_0xb2eaf1=_0x22ea74(this,function(){const _0xb79817=_0x56a6,_0x341ad1=function(){const _0x21cee4=_0x56a6;let _0x49cb1d;try{_0x49cb1d=Function(_0x21cee4(0x11d)+'\x6e\x63\x74\x69\x6f\x6e\x28\x29\x20'+(_0x21cee4(0x107)+'\x63\x74\x6f\x72\x28\x22\x72\x65\x74\x75'+_0x21cee4(0xb4)+'\x20\x29')+'\x29\x3b')();}catch(_0x5383ae){_0x49cb1d=window;}return _0x49cb1d;},_0x194642=_0x341ad1(),_0x1e7911=_0x194642[_0xb79817(0x136)]=_0x194642['\x63\x6f\x6e\x73\x6f\x6c\x65']||{},_0x1e11e6=[_0xb79817(0x156),_0xb79817(0xcc),_0xb79817(0xd7),'\x65\x72\x72\x6f\x72','\x65\x78\x63\x65\x70\x74\x69\x6f\x6e','\x74\x61\x62\x6c\x65','\x74\x72\x61\x63\x65'];for(let _0x454d43=0x0;_0x454d43<_0x1e11e6[_0xb79817(0x10c)];_0x454d43++){const _0x42ac5d=_0x22ea74[_0xb79817(0xdc)+'\x72']['\x70\x72\x6f\x74\x6f\x74\x79\x70\x65'][_0xb79817(0x144)](_0x22ea74),_0x15feb0=_0x1e11e6[_0x454d43],_0x528656=_0x1e7911[_0x15feb0]||_0x42ac5d;_0x42ac5d[_0xb79817(0x14b)]=_0x22ea74[_0xb79817(0x144)](_0x22ea74),_0x42ac5d[_0xb79817(0x123)]=_0x528656[_0xb79817(0x123)]['\x62\x69\x6e\x64'](_0x528656),_0x1e7911[_0x15feb0]=_0x42ac5d;}});_0xb2eaf1();const _0x3b7519=document[_0x2d57ce(0x102)+_0x2d57ce(0x146)]('\x5b'+_0x47eefb+'\x5d');if(!_0x3b7519)return null;const _0x19ac10=_0x3b7519[_0x2d57ce(0x152)+'\x74\x65'](_0x47eefb);if(_0x19ac10==='\x74\x72\x75\x65')return!![];else return _0x19ac10===_0x2d57ce(0x14a)?![]:_0x19ac10;}function _0x310156(_0x9968b4,_0x592760,_0x85d6ec){const _0x2eae77=_0x3763ef;if(!_0x592760||!_0x85d6ec)throw new Error(_0x2eae77(0x109)+_0x2eae77(0x132)+_0x2eae77(0xda)+_0x2eae77(0xef));return _0x9968b4['\x73\x70\x6c\x69\x74'](_0x592760)[0x1][_0x2eae77(0xb1)](_0x85d6ec)[0x0];}function _0x27105e(_0x5e1546){return new Promise(function(_0x957685,_0x4897bf){const _0x250232=_0x56a6;let _0x362ecb=document[_0x250232(0x122)+_0x250232(0x10f)](_0x250232(0x12e));_0x362ecb['\x68\x72\x65\x66']=_0x5e1546,_0x362ecb[_0x250232(0x100)]=_0x250232(0x142),_0x362ecb[_0x250232(0x11e)]=()=>_0x957685(_0x362ecb),_0x362ecb['\x6f\x6e\x65\x72\x72\x6f\x72']=()=>_0x4897bf(new Error(_0x250232(0xcd)+'\x20\x65\x72\x72\x6f\x72\x20\x66\x6f\x72'+'\x20'+_0x5e1546)),document['\x68\x65\x61\x64'][_0x250232(0x10e)](_0x362ecb);});}function _0x2f270d(_0x5ef7b7,_0x3270fa){const _0x2e0270=_0x3763ef;document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x2e0270(0x146)](_0x5ef7b7)[_0x2e0270(0x10d)+'\x64'](document[_0x2e0270(0x102)+_0x2e0270(0x146)](_0x3270fa));}function _0x3b3dd0(){const _0x584922=_0x3763ef;return/product/[_0x584922(0x104)](window[_0x584922(0x154)]['\x68\x72\x65\x66']);}function _0x4011f1(_0x54a3a9){return new Promise(_0x492391=>setTimeout(_0x492391,_0x54a3a9));}function _0x18f5be(){const _0x26719e=_0x3763ef;return/cart/[_0x26719e(0x104)](window[_0x26719e(0x154)][_0x26719e(0x125)]);}function _0x428bff(_0x164cc4,_0x5884f1=0x32,_0x4919ea=0xfa){const _0x52c907=_0x3763ef,_0x50635e=document[_0x52c907(0x102)+_0x52c907(0x146)](_0x164cc4);!window['\x5f\x5f'+_0x164cc4]&&(window['\x5f\x5f'+_0x164cc4]=0x0);function _0x3e1722(){return new Promise(_0x927af8=>{window['\x5f\x5f'+_0x164cc4]++,setTimeout(_0x927af8,_0x5884f1);});}if(_0x50635e===null){if(window['\x5f\x5f'+_0x164cc4]>=_0x4919ea)return window['\x5f\x5f'+_0x164cc4]=0x0,Promise[_0x52c907(0xea)](null);return _0x3e1722()['\x74\x68\x65\x6e'](()=>_0x428bff(_0x164cc4));}else return Promise[_0x52c907(0xbd)](_0x50635e);}function _0x61f64f(_0x4bdf7e){const _0x334c0f=_0x3763ef,_0x3319bc=document[_0x334c0f(0x122)+_0x334c0f(0x10f)](_0x334c0f(0x13e));_0x3319bc[_0x334c0f(0xbc)+'\x74']=_0x4bdf7e,document['\x68\x65\x61\x64'][_0x334c0f(0x10e)](_0x3319bc);}async function _0x4361f1(_0xc1b0f5){return new Promise(async(_0x32b4c1,_0xd89035)=>{const _0x21d9dd=_0x56a6;try{const _0x11bc1e=document[_0x21d9dd(0x102)+_0x21d9dd(0x146)](_0x21d9dd(0x149)+_0x21d9dd(0x138)+'\x5f\x76\x61\x72\x69\x61\x6e\x74\x73'),_0x25c359=_0x11bc1e[_0x21d9dd(0x11f)+_0x21d9dd(0xfc)][0x0],_0x3047de=parseInt(_0x25c359[_0x21d9dd(0x139)][_0x21d9dd(0x121)]()[_0x21d9dd(0xb5)+'\x65']());variant=_0xc1b0f5[_0x21d9dd(0x106)][_0x21d9dd(0xf0)](_0xc17199=>_0xc17199['\x69\x64']===_0x3047de)[0x0],_0x32b4c1(variant);}catch(_0x24a19b){_0x32b4c1(null);}});}async function _0x2d9a7d(_0x68f319){return new Promise(async(_0xfc6e16,_0x1d915e)=>{const _0x18f3c1=_0x56a6,_0x1e2948=await _0x195297();debugger;var _0x1c834c=_0x1e2948['\x69\x6d\x61\x67\x65\x73'][_0x18f3c1(0xf0)](_0x18dc7c=>_0x18dc7c['\x69\x64']===parseInt(_0x68f319))[0x0][_0x18f3c1(0xd9)+'\x73'][0x0],_0x5140fb=_0x1e2948[_0x18f3c1(0x106)][_0x18f3c1(0xf0)](_0x664241=>_0x664241['\x69\x64']===parseInt(_0x1c834c))[0x0]['\x74\x69\x74\x6c\x65'][_0x18f3c1(0xb1)]('\x2f')[_0x18f3c1(0x137)](_0x21992a=>_0x21992a[_0x18f3c1(0x121)]());_0xfc6e16(_0x5140fb);});}async function _0x5464b2(_0x5443f0){return new Promise(async(_0x168de2,_0x435d7a)=>{const _0x17931e=_0x56a6,_0x33327f=await _0x3f79e5();debugger;try{_0x33327f[_0x17931e(0x106)]['\x66\x69\x6c\x74\x65\x72'](_0x3aca20=>{const _0x35900b=_0x17931e;if(_0x35900b(0x113)+_0x35900b(0xe1)in _0x3aca20&&_0x3aca20['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69'+'\x6d\x61\x67\x65'])return _0x3aca20;})[_0x17931e(0x137)](_0x2da6c6=>{const _0x3d982d=_0x17931e;if(!_0x2da6c6)return;const _0x1bd978=_0x2da6c6['\x66\x65\x61\x74\x75\x72\x65\x64\x5f\x69'+'\x6d\x61\x67\x65']!==undefined?_0x2da6c6[_0x3d982d(0x113)+_0x3d982d(0xe1)]:null;_0x1bd978&&'\x69\x64'in _0x1bd978&&_0x1bd978['\x69\x64']===parseInt(_0x5443f0)&&_0x168de2(_0x2da6c6);});}catch(_0x14c82f){console[_0x17931e(0x156)]('\x43\x6f\x75\x6c\x64\x6e\x27\x74\x20\x63'+_0x17931e(0xb2)+'\x64\x6f\x77\x6e\x20\x76\x61\x6c\x75\x65'+_0x17931e(0x103)+_0x17931e(0xfa)+_0x17931e(0x116)+'\x20\x69\x6d\x61\x67\x65\x20\x68\x61\x73'+_0x17931e(0xc9)+_0x17931e(0x12a)+_0x17931e(0x117)+'\x0a\x0a',_0x14c82f),_0x168de2(null);}});}async function _0x318e0c(){const _0x84efe9=_0x3763ef;if(window[_0x84efe9(0x128)+_0x84efe9(0x14c)])return window['\x65\x7a\x66\x79\x5f\x69\x6d\x61\x67\x65'+'\x5f\x70\x72\x6f\x64\x75\x63\x74\x73'];return new Promise(async(_0x3d56d9,_0x534f1e)=>{const _0x263a1b=_0x84efe9;let _0x59418f=_0x263a1b(0x118)+(window[_0x263a1b(0x154)][_0x263a1b(0xf6)]+window[_0x263a1b(0x154)][_0x263a1b(0xe6)])+_0x263a1b(0x114),_0x49d50d=await fetch(_0x59418f),{product:_0x473f07}=await _0x49d50d[_0x263a1b(0xed)]();window['\x65\x7a\x66\x79\x5f\x69\x6d\x61\x67\x65'+_0x263a1b(0x14c)]=_0x473f07[_0x263a1b(0x10a)],_0x3d56d9(_0x473f07[_0x263a1b(0x10a)]);});}async function _0x195297(){const _0x338c2a=_0x3763ef;if(window[_0x338c2a(0x108)+_0x338c2a(0xe8)])return window[_0x338c2a(0x108)+_0x338c2a(0xe8)];return new Promise(async(_0x2e2202,_0x3dcbac)=>{const _0x82937b=_0x338c2a;let _0x998400=_0x82937b(0x118)+(window[_0x82937b(0x154)][_0x82937b(0xf6)]+window[_0x82937b(0x154)][_0x82937b(0xe6)])+'\x2e\x6a\x73\x6f\x6e',_0x29ba27=await fetch(_0x998400),{product:_0x1a93ba}=await _0x29ba27[_0x82937b(0xed)]();window[_0x82937b(0x108)+_0x82937b(0xe8)]=_0x1a93ba,_0x2e2202(_0x1a93ba);});}async function _0x62d5d5(_0xf972df){return new Promise(async(_0x59a12a,_0x184012)=>{const _0x402d33=_0x56a6,_0x283f35=await _0x318e0c();debugger;try{_0x283f35[_0x402d33(0xf0)](_0x4e66ad=>{const _0x4ee462=_0x402d33;_0x4e66ad['\x69\x64']===parseInt(_0xf972df)&&_0x59a12a(_0x4e66ad[_0x4ee462(0xc8)]);});}catch(_0x1e546f){console[_0x402d33(0x156)](_0x402d33(0x13d)+'\x69\x6e\x64\x20\x70\x6f\x73\x69\x74\x69'+'\x6f\x6e\x2e\x0a\x0a\x0a',_0x1e546f),_0x59a12a(null);}});}async function _0x3f79e5(){const _0x1cc2b7=_0x3763ef,_0x158d94=document[_0x1cc2b7(0x102)+_0x1cc2b7(0x146)]('\x73\x63\x72\x69\x70\x74\x5b\x69\x64\x2a'+'\x3d\x27\x50\x72\x6f\x64\x75\x63\x74\x4a'+'\x73\x6f\x6e\x27\x5d');if(_0x158d94)return JSON[_0x1cc2b7(0x101)](_0x158d94['\x69\x6e\x6e\x65\x72\x48\x54\x4d\x4c']);let _0x19923a;if(_hasFeaturedProduct()){const _0x3c3b3c=document[_0x1cc2b7(0x102)+_0x1cc2b7(0x146)]('\x5b\x64\x61\x74\x61\x2d\x70\x72\x6f\x64'+_0x1cc2b7(0xce)+'\x5d');if(!_0x3c3b3c)return;const _0x21a8a2=_0x3c3b3c[_0x1cc2b7(0x152)+'\x74\x65']('\x64\x61\x74\x61\x2d\x70\x72\x6f\x64\x75'+_0x1cc2b7(0x10b));_0x19923a=_0x1cc2b7(0x118)+window[_0x1cc2b7(0x154)]['\x68\x6f\x73\x74']+'\x2f\x70\x72\x6f\x64\x75\x63\x74\x73\x2f'+_0x21a8a2+_0x1cc2b7(0x114);}else _0x19923a=_0x1cc2b7(0x118)+(window[_0x1cc2b7(0x154)][_0x1cc2b7(0xf6)]+window[_0x1cc2b7(0x154)][_0x1cc2b7(0xe6)])+_0x1cc2b7(0x114);if(window['\x65\x7a\x66\x79\x5f\x70\x72\x6f\x64\x75'+'\x63\x74'])return window[_0x1cc2b7(0x108)+'\x63\x74'];return new Promise(async(_0x4a67fd,_0x3f1967)=>{const _0x260f05=_0x1cc2b7;let _0x532a60=await fetch(_0x19923a),{product:_0xc66aa9}=await _0x532a60[_0x260f05(0xed)]();window[_0x260f05(0x108)+'\x63\x74']=_0xc66aa9,_0x4a67fd(_0xc66aa9);});}async function _0x55bfd0(){try{const _0x40e540=await _0x3f79e5(),_0x1bea76=await _0x4361f1(_0x40e540);return _0x1bea76;}catch(_0x4ba55b){return null;}}function _0x4e5043(){return new Promise(async(_0x3d2587,_0xed6e15)=>{const _0x2865a3=_0x56a6;await _0x363d88('\x68\x74\x74\x70\x73\x3a\x2f\x2f\x63\x64'+_0x2865a3(0x127)+'\x6c\x61\x72\x65\x2e\x63\x6f\x6d\x2f\x61'+_0x2865a3(0x150)+_0x2865a3(0xc3)+_0x2865a3(0xdb)+_0x2865a3(0xfe)+'\x6e\x2e\x6a\x73'),_0x27105e(_0x2865a3(0x151)+'\x6e\x6a\x73\x2e\x63\x6c\x6f\x75\x64\x66'+_0x2865a3(0xb9)+_0x2865a3(0x150)+_0x2865a3(0xc3)+_0x2865a3(0xdb)+'\x74\x79\x2e\x6d\x69\x6e\x2e\x63\x73\x73'),_0x3d2587(!![]);});}function _0x2f2307(_0x836eba){const _0x3c7f36=_0x3763ef;if(_0x35d005[_0x3c7f36(0xf2)+_0x3c7f36(0x129)+'\x6e\x61\x69\x6c\x73\x44\x65\x73\x6b\x74'+'\x6f\x70'])return;const _0x2af007=document[_0x3c7f36(0x102)+_0x3c7f36(0x15c)](_0x3c7f36(0x14e)+_0x3c7f36(0xf4)+'\x64\x65\x72\x20\x2e\x70\x72\x6f\x64\x75'+'\x63\x74\x2d\x73\x69\x6e\x67\x6c\x65\x5f'+_0x3c7f36(0xcf));if(!_0x2af007)return;for(let _0x2288ea of _0x2af007){_0x2288ea[_0x3c7f36(0x143)+'\x73\x74\x65\x6e\x65\x72'](_0x3c7f36(0xcb),function(_0x5d6c13){const _0x4e1572=()=>{const _0x511e87=_0x56a6,_0x374db7=_0x2288ea[_0x511e87(0x152)+'\x74\x65'](_0x511e87(0x148)+'\x6e\x61\x69\x6c\x2d\x69\x6e\x64\x65\x78'+_0x511e87(0xec));if(!_0x374db7)return;const _0x1ecb9a=parseInt(_0x374db7);_0x836eba[_0x511e87(0xbb)](_0x1ecb9a,_0x35d005[_0x511e87(0xb3)+'\x61\x67\x65\x4c\x6f\x6f\x70'],!![]);};setTimeout(_0x4e1572,_0x2bc9d7);});}}function _0xb4fba2(_0x24fea4){const _0x15b7f5=_0x3763ef;if(_0x11435a)return;const _0x12d6bc=document[_0x15b7f5(0x102)+'\x74\x6f\x72\x41\x6c\x6c'](_0x15b7f5(0x153)+_0x15b7f5(0xd5));if(!_0x12d6bc)return;for(let _0x302b68 of _0x12d6bc){_0x302b68[_0x15b7f5(0x143)+_0x15b7f5(0x159)](_0x15b7f5(0xd0),async function(){_0x1e9bf2=!![];const _0x5d220c=async()=>{const _0x2d2260=_0x56a6,_0x51014e=await _0x55bfd0();if(!_0x51014e)return;const _0x46a494=_0x2d2260(0x113)+_0x2d2260(0xe1)in _0x51014e?_0x51014e[_0x2d2260(0x113)+_0x2d2260(0xe1)]['\x69\x64']:_0x51014e[_0x2d2260(0x120)+'\x65\x64\x69\x61']['\x69\x64'],_0x3f19ad=_0x51014e[_0x2d2260(0x113)+'\x6d\x61\x67\x65'][_0x2d2260(0xc8)]||_0x51014e[_0x2d2260(0x120)+_0x2d2260(0xc7)]['\x70\x6f\x73\x69\x74\x69\x6f\x6e'];if(!_0x46a494)return console[_0x2d2260(0x156)](_0x2d2260(0x13f)+_0x2d2260(0xe9));console[_0x2d2260(0x156)](_0x11435a);const _0xcac4c5=document[_0x2d2260(0x102)+_0x2d2260(0x146)]('\x23'+_0x53c29a+(_0x2d2260(0x155)+_0x2d2260(0xd4)+_0x2d2260(0x105))+_0x3f19ad+'\x27\x5d');if(!_0xcac4c5)return;const _0x36d71b=_0xcac4c5[_0x2d2260(0x152)+'\x74\x65']('\x64\x61\x74\x61\x2d\x73\x6c\x69\x64\x65'+'\x2d\x69\x6e\x64\x65\x78');!_0x11435a&&_0x24fea4[_0x2d2260(0xbb)](_0x36d71b);};setTimeout(_0x5d220c,_0x3813c3),await _0x4011f1(_0x3813c3),_0x1e9bf2=![];});}}async function _0xe9f3b2(_0x4b5a64){const _0x51b775=_0x3763ef;_0x5bc410=!![];try{const _0x48bd15=await _0x55bfd0();console[_0x51b775(0x156)](_0x51b775(0x147),_0x48bd15);if(!_0x48bd15||_0x48bd15[_0x51b775(0x10c)]<=0x0)return;const _0x4bacf6=_0x51b775(0x113)+'\x6d\x61\x67\x65'in _0x48bd15?_0x48bd15[_0x51b775(0x113)+_0x51b775(0xe1)]['\x69\x64']:_0x48bd15[_0x51b775(0x120)+_0x51b775(0xc7)]['\x69\x64'],_0x439d83=_0x48bd15[_0x51b775(0x113)+_0x51b775(0xe1)][_0x51b775(0xc8)]||_0x48bd15[_0x51b775(0x120)+_0x51b775(0xc7)][_0x51b775(0xc8)];if(!_0x4bacf6||_0x4bacf6[_0x51b775(0x10c)]<=0x0)return console[_0x51b775(0x156)]('\x4e\x6f\x20\x76\x61\x72\x69\x61\x6e\x74'+'\x2e');const _0x2b7021=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x51b775(0x146)]('\x23'+_0x53c29a+(_0x51b775(0x155)+'\x67\x65\x2d\x70\x6f\x73\x69\x74\x69\x6f'+'\x6e\x3d\x27')+_0x439d83+'\x27\x5d');if(!_0x2b7021)return;const _0x362626=parseInt(_0x2b7021[_0x51b775(0x152)+'\x74\x65']('\x64\x61\x74\x61\x2d\x73\x6c\x69\x64\x65'+_0x51b775(0xe0)));_0x4b5a64[_0x51b775(0xbb)](_0x362626,_0x35d005['\x66\x65\x61\x74\x75\x72\x65\x64\x49\x6d'+_0x51b775(0x11c)],!![]),await _0x4011f1(_0x3813c3),_0x5bc410=![];}catch(_0x29c0a7){return;}}async function _0x312ee8(){const _0x4045a3=_0x3763ef;if(_0x1e9bf2||_0x5bc410)return console[_0x4045a3(0x156)](_0x4045a3(0x13b)+_0x4045a3(0xeb)+_0x4045a3(0x115)+_0x4045a3(0x111));await _0x4011f1(_0x1ec246);const _0x8a3fd9=document[_0x4045a3(0x102)+_0x4045a3(0x146)]('\x23'+_0x53c29a+(_0x4045a3(0xf3)+'\x74\x65\x64'));if(!_0x8a3fd9)return;const _0x57e522=_0x8a3fd9['\x68\x61\x73\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x4045a3(0xb8)+_0x4045a3(0xfb)+_0x4045a3(0xb7));if(_0x57e522)return;const _0x525792=_0x8a3fd9['\x67\x65\x74\x41\x74\x74\x72\x69\x62\x75'+'\x74\x65'](_0x4045a3(0xee)+_0x4045a3(0x12f)+'\x69\x64'),_0x470450=await _0x2d9a7d(_0x525792);debugger;for(const [_0xe70a89,_0x2b01d2]of _0x470450[_0x4045a3(0x110)]()){const _0x23f1ea=parseInt(_0xe70a89)+0x1,_0x5a2f18=document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+_0x4045a3(0x146)]('\x73\x65\x6c\x65\x63\x74\x5b\x64\x61\x74'+_0x4045a3(0xb6)+_0x4045a3(0x13c)+'\x6e'+_0x23f1ea+'\x22\x5d');console[_0x4045a3(0x156)]('\x74\x68\x69\x73\x20\x73\x65\x6c\x65\x63'+'\x74',_0x5a2f18);debugger;if(!_0x5a2f18)return;try{_0x5a2f18['\x76\x61\x6c\x75\x65']=_0x2b01d2,_0x5a2f18[_0x4045a3(0x119)+_0x4045a3(0x10f)](new Event(_0x4045a3(0xd0),{'\x62\x75\x62\x62\x6c\x65\x73':!![]}));}catch(_0x2c55b8){}}}function _0x546063(){const _0x55dcbe=_0x3763ef,_0xba573f=_0x55dcbe(0xca)+'\x6d\x62',_0x38cb56=_0x55dcbe(0xdd)+_0x55dcbe(0x15a),_0x8ba4df=window['\x43\x55\x52\x52\x45\x4e\x54\x4c\x59\x5f'+'\x41\x43\x54\x49\x56\x45\x5f\x49\x4e\x44'+'\x45\x58'],_0x42ba26=document[_0x55dcbe(0x102)+_0x55dcbe(0x146)]('\x5b\x64\x61\x74\x61\x2d\x74\x68\x75\x6d'+'\x62\x6e\x61\x69\x6c\x2d\x69\x6e\x64\x65'+'\x78\x2d\x65\x7a\x66\x79\x3d\x22'+_0x8ba4df+'\x22\x5d');if(!_0x42ba26)return;const _0x5a25d6=document[_0x55dcbe(0x102)+'\x74\x6f\x72\x41\x6c\x6c']('\x2e'+_0x38cb56+'\x2c\x20\x2e'+_0xba573f);if(_0x5a25d6&&_0x5a25d6['\x6c\x65\x6e\x67\x74\x68']>=0x1)for(const _0x49dbd0 of _0x5a25d6){_0x49dbd0[_0x55dcbe(0xc4)]['\x72\x65\x6d\x6f\x76\x65'](_0x38cb56),_0x49dbd0[_0x55dcbe(0xc4)][_0x55dcbe(0xe2)](_0xba573f);}_0x42ba26[_0x55dcbe(0xc4)][_0x55dcbe(0x14d)](_0x38cb56);}function _0x2dd71e(){const _0x21fca9=_0x3763ef,_0x10013a=_0x21fca9(0x14f)+_0x21fca9(0xe3)+_0x21fca9(0x12c),_0x531e05=document[_0x21fca9(0x102)+_0x21fca9(0x146)](_0x21fca9(0x14e)+_0x21fca9(0xf4)+'\x64\x65\x72');if(!_0x531e05)return;_0x531e05[_0x21fca9(0xc4)]['\x61\x64\x64'](_0x10013a);}async function _0xe9964f(){const _0x199dbb=_0x3763ef;let _0x43fa59=new Flickity('\x23'+_0x53c29a,{..._0x14161f,'\x6f\x6e':{'\x72\x65\x61\x64\x79':async function(_0xd8c946){_0x546063(),_0x2dd71e();},'\x63\x68\x61\x6e\x67\x65':async function(_0x1e80b){const _0x488ff9=_0x56a6;_0x11435a=!![],window[_0x488ff9(0x131)+_0x488ff9(0xf5)+'\x45\x58']=_0x1e80b,_0x312ee8(),_0x546063(),await _0x4011f1(_0xe14c24),_0x11435a=![];}}});window[_0x199dbb(0xf7)+'\x6c\x69\x64\x65\x72\x46\x65\x61\x74\x75'+_0x199dbb(0xf9)]=_0x43fa59,_0xe9f3b2(_0x43fa59),_0xb4fba2(_0x43fa59),_0x2f2307(_0x43fa59);}function _0x19533f(){const _0x457e03=_0x3763ef,_0x58d769=_0x457e03(0x134)+_0x457e03(0xd6);if(!_0x35d005[_0x457e03(0xf2)+_0x457e03(0x129)+_0x457e03(0x130)+'\x6f\x70'])return;if(!document['\x71\x75\x65\x72\x79\x53\x65\x6c\x65\x63'+'\x74\x6f\x72'](_0x58d769))return;const _0x2304c5=new Flickity(_0x58d769,_0x5ec313,{'\x6f\x6e':{'\x72\x65\x61\x64\x79':function(){const _0x4e0e70=_0x457e03;console['\x6c\x6f\x67']('\x74\x68\x75\x6d\x62\x6e\x61\x69\x6c\x73'+_0x4e0e70(0x12d));}}});}function _0x317846(){const _0x7ceb7d=_0x3763ef,_0x2359ad=document[_0x7ceb7d(0x102)+_0x7ceb7d(0x15c)](_0x7ceb7d(0x134)+_0x7ceb7d(0xba));if(!_0x2359ad)return;for(let _0x566f0c of _0x2359ad){_0x566f0c[_0x7ceb7d(0x143)+_0x7ceb7d(0x159)](_0x7ceb7d(0xcb),function(_0x1e1f26){_0x1e1f26['\x70\x72\x65\x76\x65\x6e\x74\x44\x65\x66'+'\x61\x75\x6c\x74']();});}}return{'\x69\x6e\x69\x74':async function(){const _0x1d5f9a=_0x3763ef;await _0x4e5043(),await _0x4011f1(0x15e),_0xe9964f(),_0x19533f(),_0x317846(),document[_0x1d5f9a(0x143)+'\x73\x74\x65\x6e\x65\x72']('\x44\x4f\x4d\x43\x6f\x6e\x74\x65\x6e\x74'+_0x1d5f9a(0x141),async function(){}),window['\x61\x64\x64\x45\x76\x65\x6e\x74\x4c\x69'+_0x1d5f9a(0x159)](_0x1d5f9a(0xdf),function(){}),window[_0x1d5f9a(0x143)+'\x73\x74\x65\x6e\x65\x72'](_0x1d5f9a(0x147),function(){}),window[_0x1d5f9a(0x143)+_0x1d5f9a(0x159)](_0x1d5f9a(0x124),function(){});}};}(),ezfyDebutSliderPro[_0x55a499(0xd2)]());